import React from 'react';
import { Link } from 'react-router-dom';
import buildingImg from '../assets/building.png';

const LegalDocs = () => {
  return (
    <div className="bg-[#041424] min-h-screen w-full font-sans text-white">
      
      {/* 1. Hero Section */}
      <section className="relative w-full pt-32 pb-24 md:pt-40 md:pb-32 flex items-center overflow-hidden border-b border-gray-800">
        <div className="absolute inset-0 z-0">
          <img src={buildingImg} alt="Corporate Building" className="w-full h-full object-cover opacity-20 mix-blend-luminosity" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#041424] via-[#041424]/90 to-transparent"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="flex items-center gap-2 text-xs sm:text-sm font-bold tracking-widest mb-6 uppercase">
            <Link to="/" className="text-white hover:text-[#D4AF37]">Home</Link>
            <span className="text-gray-500 material-symbols-outlined text-sm">chevron_right</span>
            <span className="text-[#D4AF37]">Legal & Documentation</span>
          </div>
          
          <div className="max-w-3xl">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight tracking-tight uppercase">
              Legal & <br/><span className="text-[#D4AF37]">Documentation</span>
            </h1>
            <p className="text-xl text-gray-300 font-light mb-8 border-l-2 border-[#D4AF37] pl-6 uppercase tracking-widest">
              Transparency. Trust. Total Compliance.
            </p>
            <p className="text-sm sm:text-base text-gray-400 max-w-xl leading-relaxed">
              At HBB0011 Realty Realtors, we follow a completely transparent and legally compliant approach in every project to ensure peace of mind for our customers and investors.
            </p>
          </div>
        </div>
      </section>

      {/* 2. Commitment Strip */}
      <section className="py-12 bg-[#06121e] border-b border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-2 md:grid-cols-5 gap-8">
          {[
            { icon: 'shield_person', title: '100% Legal Compliance' },
            { icon: 'description', title: 'Transparent Documentation' },
            { icon: 'balance', title: 'RERA Compliant' },
            { icon: 'lock', title: 'Safe & Secure Investments' },
            { icon: 'verified_user', title: 'Customer Protection' }
          ].map((item, i) => (
            <div key={i} className="flex flex-col items-center text-center">
              <span className="material-symbols-outlined text-[#D4AF37] text-3xl sm:text-4xl font-light mb-3">{item.icon}</span>
              <p className="text-[10px] font-bold text-white uppercase tracking-widest leading-relaxed">{item.title}</p>
            </div>
          ))}
        </div>
      </section>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 space-y-20">
        
        {/* 3. Documents & Partners Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-10">
          
          {/* Documents We Ensure */}
          <section className="bg-[#06121e] border border-gray-800 rounded-sm p-8 sm:p-10">
            <h3 className="text-sm font-bold text-white uppercase tracking-widest mb-8 border-b border-gray-800 pb-4">Documents We Ensure</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {[
                'Clear Title Deed', 'RERA Registration', 'Approved Building Plan', 
                'Encumbrance Certificate', 'Land Use Approvals', 'Environmental Clearance',
                'Completion Certificate', 'Property Tax Receipts', 'Statutory Approvals', 'Sale Agreement'
              ].map((doc, i) => (
                <div key={i} className="flex items-start gap-3">
                  <span className="material-symbols-outlined text-[#D4AF37] text-base mt-0.5">check_circle</span>
                  <span className="text-gray-400 text-xs sm:text-sm">{doc}</span>
                </div>
              ))}
            </div>
          </section>

          {/* Legal Partners */}
          <section className="bg-[#06121e] border border-gray-800 rounded-sm p-8 sm:p-10 flex flex-col">
            <h3 className="text-sm font-bold text-white uppercase tracking-widest mb-2">Our Legal Partners</h3>
            <p className="text-gray-400 text-xs mb-8">We work with leading legal experts to ensure all projects are legally sound.</p>
            
            <div className="bg-[#041424] border border-gray-800 p-6 rounded-sm flex-grow">
              <h4 className="text-[#D4AF37] font-bold text-[10px] uppercase tracking-widest mb-6">Expertise In</h4>
              <ul className="space-y-4">
                {['Real Estate Law', 'Property Documentation', 'RERA & Regulatory Compliance', 'Litigation Support', 'Due Diligence'].map((exp, i) => (
                  <li key={i} className="flex items-start gap-3 text-white text-xs">
                    <span className="material-symbols-outlined text-[#D4AF37] text-base">check_circle</span>
                    {exp}
                  </li>
                ))}
              </ul>
            </div>
          </section>
        </div>

        {/* 4. Process Section */}
        <section className="py-10">
          <h3 className="text-center text-sm font-bold text-white uppercase tracking-widest mb-16">Our Documentation Process</h3>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
            {[
              { num: '01', title: 'Consultation' },
              { num: '02', title: 'Document Verification' },
              { num: '03', title: 'Due Diligence' },
              { num: '04', title: 'Documentation' },
              { num: '05', title: 'Registration' },
              { num: '06', title: 'After-Sales Support' }
            ].map((step, i) => (
              <div key={i} className="flex flex-col items-center text-center group">
                <div className="w-16 h-16 rounded-full bg-[#06121e] border border-[#D4AF37] flex items-center justify-center text-[#D4AF37] font-bold text-sm mb-4 group-hover:bg-[#D4AF37] group-hover:text-[#041424] transition-colors">
                  {step.num}
                </div>
                <h4 className="text-white text-[10px] font-bold uppercase tracking-widest">{step.title}</h4>
              </div>
            ))}
          </div>
        </section>

        {/* 5. CTA Banner */}
        <div className="bg-[#06121e] border border-gray-800 rounded-sm p-10 flex flex-col lg:flex-row items-center justify-between gap-8 mt-20">
          <div className="text-center lg:text-left">
            <h3 className="text-xl sm:text-2xl text-white font-light mb-2">Buy with Confidence. Invest with Assurance.</h3>
            <p className="text-gray-400 text-sm">Every document. Every approval. Every detail. We've got you covered.</p>
          </div>
          <button className="bg-[#D4AF37] text-[#041424] font-bold text-[10px] uppercase tracking-widest py-4 px-8 rounded-sm hover:bg-white transition-colors flex items-center gap-2">
            Schedule a Consultation <span className="material-symbols-outlined text-base">event</span>
          </button>
        </div>

      </main>
    </div>
  );
};

export default LegalDocs;